module.exports = __webpack_public_path__ + "custom-software.34Cjk2wV.svg";